module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/leader-seminar/font/notokr-light.woff
// module id = H+7z
// module chunks = 0